<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    福保站<br>
站点介绍<br>
福保站位于深圳市福田区益田路与绒花路、红花路交汇处，北侧：深福保大厦、长宝大厦、城市3米6公寓，南侧：长平商务大厦、福田保税区广场公园、长富金茂大厦、福年广场、深圳金融科技创新中心，西侧：德宝物流大厦、T8旅游创意园，东侧：长宝大厦（东侧），紧急出入口是：A出入口（红花路南侧）。车站出入口采用自然采光设计，既美观又环保，益田站以白色为主基调，着色稳重，按一级防火建筑标准设计和建造。该站为地下站。<br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	--	--	3号线	2分15-20秒	4分30秒<br>
双龙	06:17	23:00	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	--	--	3号线	3分15秒	5分钟<br>
双龙	06:18	23:00	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	--	--	3号线	3分15秒	5分钟<br>
双龙	06:18	00:00	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
红花路南侧（西）、槟榔道（南）、深福保国际会议中心、市花路（西）、海虹道（南）、金花路（西）<br><br>
B出入口:
红花路南侧（东）、福田保税区广场公园、市花路（东）、金花路（东）、红棉道、紫荆道（南）<br><br>
E1口:<br>
绒花路北侧（东）、益田路东侧、圆梦园、紫荆道（北）、南光紫荆苑、桂花路（东）、红棉道西侧（北）E2口<br>
红棉道西侧（北）E3口:<br>
绒花路北侧（东）、益田路西侧、兰花道东侧、桂花路（东）<br><br>
E4口:<br>
绒花路北侧（东）、益田路西侧、兰花道东侧、桂花路（东）<br><br>
F1口:<br>
绒花路北侧（西）、槟榔道（北）、东海苑、天健时尚明苑、福保派出所、福源花园、海虹道（北）、福田区人民检察院派驻、桂花路（西）、桂花路都市公园F2口<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 福田保税区三号门<br>
B692E1口<br><br>
E2口:<br>
公交站名： 绒花路口东②<br>
26，B618，M120，M441，M476<br><br>
F1口:<br>
公交站名： 绒花路口西②<br>
26,385，M441，M453<br><br>
F2口:<br>
公交站名： 绒花路口西①<br>
60，M476，N9、M120<br>

公交站名： 福源花园二期<br>
52，60,62，B618，M120，M476，N9<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>